import React from 'react'

const ExtraInfo = () => {
  return (
    <section>
            <h4>
        <strong>Extra Info</strong>
      </h4>
      <p>
        Our apartment is really clean and we like to keep it that way. Enjoy the
        lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat.
      </p>
      <p>
        We accept: <i className="fa fa-credit-card w3-large" />{" "}
        <i className="fa fa-cc-mastercard w3-large" />{" "}
        <i className="fa fa-cc-amex w3-large" />{" "}
        <i className="fa fa-cc-cc-visa w3-large" />
        <i className="fa fa-cc-paypal w3-large" />
      </p>

    </section>
  )
}

export default ExtraInfo